// istanbul ignore file
import { Validate } from '@deporvillage/utils-library-component';

const Customer = {
    email: {
        id: 'email',
        type: 'email',
        label: 'form.label.email',
        value: null,
        error: null,
        validate: [
            Validate.email,
        ],
    },
};
export default Customer;
